import type { RowData } from "@tanstack/react-table";

import { useDataTableContext } from "./use-data-table-context";

function useDataTablePaginationProps() {
  const { table, search, handlePageChange, handlePageSizeChange, meta } =
    useDataTableContext<RowData, unknown>();
  return {
    pagination: { pageIndex: search.page - 1, pageSize: search.pageSize },
    meta,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    canPreviousPage: table.getCanPreviousPage(),
    canNextPage: table.getCanNextPage(),
  } as const;
}

export { useDataTablePaginationProps };
